import { render } from "./package.vue?vue&type=template&id=2f58bb3e"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__